document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    if(
      e.target.closest('.add-to-cart') || 
      e.target.closest('.t4s-btn-add-cart') || 
      e.target.closest('.product-form__cart-submit')
    ) {
      setTimeout(function() {
        window.ShopifyAnalytics && window.ShopifyAnalytics.lib.track('Added to Cart');
      }, 500); // wait for cart drawer to update
    }
  });
});
